import { useCallback } from 'react';

import * as server from '../server';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';

export const useGetPlayerData = () => {
    const dynamicReducerDispatch = useDynamicReducerDispatch();

    return useCallback(async () => {
        const response = await server.getPlayerHaveIdCopyFax();
        const { haveidcopyfax } = response.data;

        dynamicReducerDispatch(actions.setHaveCopyIDFax(haveidcopyfax));
    }, [
        dynamicReducerDispatch
    ]);
};
